'use client';
import { useLocation } from 'react-router';
import { useWebsiteAppContext } from '../hooks/useWebsiteAppContext';
export function GlobalErrorBanner() {
  const { error } = useWebsiteAppContext();
  const location = useLocation();
  return error && location.pathname !== '/order-success' ? (
    <p className="text-error">{error}</p>
  ) : null;
}
